import { render, staticRenderFns } from "./CsAsignacionesForm.vue?vue&type=template&id=29af84bd"
import script from "./CsAsignacionesForm.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesForm.vue?vue&type=script&lang=js"
import style0 from "./CsAsignacionesForm.vue?vue&type=style&index=0&id=29af84bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports